import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: null,
  fieldErrors: [],
  severity: "error",
  displayToUser: true,
  timestamp: null,
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError(state, action) {
      const {
        message = "Request failed",
        fieldErrors = [],
        severity = "error",
        displayToUser = true,
      } = action.payload || {};

      state.message = message;
      state.fieldErrors = Array.isArray(fieldErrors) ? fieldErrors : [];
      state.severity = severity || "error";
      state.displayToUser = displayToUser !== false;
      state.timestamp = Date.now();
    },
    clearError(state) {
      state.message = null;
      state.fieldErrors = [];
      state.severity = "error";
      state.displayToUser = true;
      state.timestamp = null;
    },
  },
});

export const errorActions = errorSlice.actions;
export default errorSlice.reducer;
